<template>
  <div class="audit-record-content page-card-wrapper page-card-wrapper-adapt-actual-width" style="margin-top: 75px;">
    <div class="page-card-title">
      <span class="page-card-title-text">Audit Record</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content">
        <el-form ref="form" :model="form" :rules="rules" size="small" label-position="top">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Carer Cost ($) Per Hour" prop="CarerCostPerHour">
                <el-input v-model="form.CarerCostPerHour" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Change Time in Mins" prop="ChangeTimeInMins">
                <el-input v-model="form.ChangeTimeInMins" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Check Time in Mins" prop="CheckTimeInMins">
                <el-input v-model="form.CheckTimeInMins" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="CO2 Weight (kg) per Diaper Disposal" prop="CO2WeightPerDiaperDisposal">
                <el-input v-model="form.CO2WeightPerDiaperDisposal" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="CO2 Weight (kg) per Load" prop="CO2WeightPerLoad">
                <el-input v-model="form.CO2WeightPerLoad" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Detergent Weight (kg) per Load" prop="DetergentWeightPerLoad">
                <el-input v-model="form.DetergentWeightPerLoad" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Each Shift in Hours" prop="EachShiftInHrs">
                <el-input v-model="form.EachShiftInHrs" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Laundry Cost ($) per Linen" prop="LaundryCostPerLinen">
                <el-input v-model="form.LaundryCostPerLinen" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Leakage Cleanup Time in Mins" prop="LeakageCleanUpTimeInMins">
                <el-input v-model="form.LeakageCleanUpTimeInMins" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Linen Weight (kg) per Leakage" prop="LinenWeightPerLeakage">
                <el-input v-model="form.LinenWeightPerLeakage" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Per Diaper Cost ($) in Dollar" prop="PerDiaperCostInDollar">
                <el-input v-model="form.PerDiaperCostInDollar" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Per Load (kg)" prop="PerLoad">
                <el-input v-model="form.PerLoad" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Total Patients" prop="TotalPatients">
                <el-input v-model="form.TotalPatients" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="text-center">
            <el-button class="save-btn min-w-100" :loading="saveLoading" @click="submitForm('form')">{{
          $t('text.save').toUpperCase() }}</el-button>
            <div class="red-font">* Changes will take for a minute before reflecting on a chart</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      loading: false,
      saveLoading: false,
      form: {
        CheckTimeInMins: null,
        TotalPatients: null,
        ChangeTimeInMins: null,
        LeakageCleanUpTimeInMins: null,
        EachShiftInHrs: null,
        LinenWeightPerLeakage: null,
        PerLoad: null,
        DetergentWeightPerLoad: null,
        CarerCostPerHour: null,
        LaundryCostPerLinen: null,
        PerDiaperCostInDollar: null,
        CO2WeightPerLoad: null,
        CO2WeightPerDiaperDisposal: null
      },
      rules: {
        CheckTimeInMins: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        TotalPatients: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        ChangeTimeInMins: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        LeakageCleanUpTimeInMins: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        EachShiftInHrs: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        LinenWeightPerLeakage: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        PerLoad: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        DetergentWeightPerLoad: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        CarerCostPerHour: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        LaundryCostPerLinen: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        CO2WeightPerLoad: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        CO2WeightPerDiaperDisposal: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleSave()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleSave() {
      this.saveLoading = true
      ApiService.UpdateOrganisationAudit(this.$store.getters[`user/selecteOrganisationId`], this.form)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
        })
    },
    getDetail() {
      this.loading = true
      ApiService.GetOrganisationAudit(this.$store.getters[`user/selecteOrganisationId`])
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.form = response.data.data
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
